import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-full py-[0.25rem] px-[0.625rem] leading-tight text-xs font-medium w-[6rem] whitespace-nowrap shrink-0 transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-emerald-50 text-emerald-700",
        error: "bg-rose-50 text-destructive",
        success: "bg-primary-25 text-primary-500",
        summaryLength: "bg-secondary-50 text-secondary-foreground w-auto",
        role: "bg-primary-25 text-primary-500 w-auto border-transparent",
        demographic:
          "bg-secondary-50 text-foreground w-auto border-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <div
      data-testid="badge"
      className={cn(badgeVariants({ variant }), "badge", className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
